import { render } from "./Navbar.vue?vue&type=template&id=24d7c95c&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=24d7c95c&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d7c95c"]])

export default __exports__